import { z } from "zod";

import { VERTICAL_NAMES } from "../../../constants/constants";
import VerticalRegistry from "../../../constants/verticalRegistry";
import { phoneFieldSchema } from "./phoneFieldSchema";

export const searchSchema = z.object({
  vertical: z.string().min(1, "Vertical is required"),
  phone: phoneFieldSchema,
  uam_id: z.string().regex(/^\d*$/, "Only integers are allowed").optional(),
  admission_number: z
    .string()
    .refine(
      (val) => val === "" || val.length >= 2,
      "Minimum 2 characters required",
    )
    .optional(),
});

export const validateSearchForm = (values) => {
  const errors = {};

  if (!values.vertical) {
    errors.vertical = "Vertical is required";
    return errors;
  }

  if (values.vertical === VERTICAL_NAMES.IL_SCHOOLS && !values.branch_name) {
    errors.branch = "Branch is required for IL Schools";
    return errors;
  }

  const verticalObj = VerticalRegistry.getVerticalByName(values.vertical);
  if (!verticalObj) return errors;

  const config = verticalObj.searchConfig;
  if (!config) return errors;

  const allowedFields = Object.keys(config).filter((key) => config[key]);
  const isAnyFilled = allowedFields.some((field) => {
    const fieldValue = values[field];
    if (!fieldValue) return false;
    return fieldValue.trim() !== "";
  });

  if (!isAnyFilled) {
    errors.general = "Enter at least one search parameter";
  }

  return errors;
};
